import React, { useEffect, useState } from "react";
import firebase from "../../config/firebase";
import GroupList from "./GroupList";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { GlobalConfirmModal, GlobalSuccessModal } from "../../components/modalGlobal/modalGlobal";

function GroupPage() {
  const db = firebase.firestore();

  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [groupToDelete, setGroupToDelete] = useState(null);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  // buscar grupos
  useEffect(() => {
    const unsubscribe = db
      .collection("tb_group")
      .orderBy("name")
      .onSnapshot(
        (snapshot) => {
          const data = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          setGroups(data);
          setLoading(false);
        },
        (error) => {
          console.error("Erro ao buscar grupos:", error);
          setLoading(false);
        }
      );

    return () => unsubscribe();
  }, []);

  // abrir modal de exclusão
  const handleDeleteClick = (group) => {
    setGroupToDelete(group);
    setOpenConfirmModal(true);
  };

  // confirmar exclusão
  const handleConfirmDelete = async () => {
    setOpenConfirmModal(false);
    if (!groupToDelete) return;

    try {
      await db.collection("tb_group").doc(groupToDelete.id).delete();
      setOpenSuccessModal(true);
    } catch (error) {
      console.error(error);
      alert("Erro ao excluir o grupo.");
    }
  };

  return (
    <NewMiniDrawer
      divOpen={
        <>
          <GroupList
            groups={groups}
            loading={loading}
            openDeleteModal={handleDeleteClick}
          />
          <GlobalConfirmModal
            open={openConfirmModal}
            handleClose={() => setOpenConfirmModal(false)}
            handleConfirm={handleConfirmDelete}
            title="Excluir grupo?"
            subtitle={groupToDelete ? `Deseja realmente excluir o grupo "${groupToDelete.name}"?` : "Esta ação não poderá ser desfeita."}
          />
          <GlobalSuccessModal
            open={openSuccessModal}
            handleClose={() => setOpenSuccessModal(false)}
            title="Grupo excluído com sucesso!"
          />
        </>
      }
    />
  );
}

export default GroupPage;
